import React from 'react';

import AntSelect from 'antd/es/select';
import Tooltip from 'antd/es/tooltip';

import { classNames, isEmpty } from 'util/utils';

import infoSvg from 'assets/svg/info.svg';
import './input.less';

export const Label = React.memo((props) => {
  const { children, info, required, ...rest } = props;

  return (
    <label {...rest}>
      {children}
      {Boolean(required) && <span style={{ marginLeft: '2px', color: props.value ? 'green' : 'red' }}>*</span>}
      {!isEmpty(info) && (
        <Tooltip overlayClassName="Tool" placement="topLeft" title={info}>
          <span>
            <img
              style={{ cursor: 'pointer', marginLeft: '6px', marginBottom: '5px', width: '16px', height: '16px' }}
              src={infoSvg}
            />
          </span>
        </Tooltip>
      )}
    </label>
  );
});
Label.displayName = 'Label';

export const Input = React.memo((props) => {
  const { children, className, ...rest } = props;

  return (
    <div className={classNames(['input-wrapper', className])}>
      <input {...rest}>{children}</input>
    </div>
  );
});
Input.displayName = 'Input';

export const Select = AntSelect;

export const Error = React.memo((props) => {
  const { children } = props;
  if (isEmpty(children)) return <span>&nbsp;</span>;
  return <span style={{ color: 'red' }}>{children}</span>;
});
Error.displayName = 'Error';

export const Field = React.memo((props) => {
  const { children, className, hasErrors, ...rest } = props;

  return (
    <div key="Field" className={classNames(['from-group', hasErrors && 'has-errors'])} {...rest}>
      {children}
      <br />
    </div>
  );
});
Field.displayName = 'Field';
